// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__20zFA","info":"PatientInfo_info__121Oa"};